import APIService from "@/services/APIService.js";

const apiUf = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/uf"
});

export default {
  getAll(limit, page, filters) {
    return apiUf.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nom_uf",
        ...filters
      }
    });
  },
};
